module.exports = __webpack_public_path__ + "media/images/logoUach-c6220c20.png";